import React from 'react';
import { IconProps } from '../types';

export const PromotionIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M1.33337 9.33334H30.6667" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
        <path
            d="M30.6667 12V4C30.6667 2.52724 29.4728 1.33334 28 1.33334H4.00004C2.52728 1.33334 1.33337 2.52724 1.33337 4V28C1.33337 29.4728 2.52728 30.6667 4.00004 30.6667H16"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M5.33333 6.66667C6.06971 6.66667 6.66667 6.06971 6.66667 5.33333C6.66667 4.59695 6.06971 4 5.33333 4C4.59695 4 4 4.59695 4 5.33333C4 6.06971 4.59695 6.66667 5.33333 6.66667Z"
            fill={color}
        />
        <path
            d="M9.33333 6.66667C10.0697 6.66667 10.6667 6.06971 10.6667 5.33333C10.6667 4.59695 10.0697 4 9.33333 4C8.59695 4 8 4.59695 8 5.33333C8 6.06971 8.59695 6.66667 9.33333 6.66667Z"
            fill={color}
        />
        <path
            d="M21.3333 14.6667H6.66663V21.3333H13.3333"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M6.66663 25.3333L13.3333 25.3333"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M22.9919 27.1458L23.8802 28.9491C24.1741 29.6076 23.8786 30.379 23.2201 30.6729C22.5616 30.9668 21.7902 30.6713 21.4963 30.0128L19.0182 24.6653"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path
            d="M29.5128 27.6281L23.0171 24.6594H19.7693C18.4238 24.6594 17.3334 23.5348 17.3334 22.1474C17.3334 20.7599 18.4238 19.6354 19.7693 19.6354H23.0171L29.5128 16.6667V27.6281Z"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
    </svg>
);
